import React from 'react'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'

import microphone from '../images/microphone.gif'
import { T } from '../utils/Typography'
import { Icons } from '../components'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTrackAnalytics } from '../utils/analytics'

type HomeProps = {}

const Home: React.FC<HomeProps> = React.memo(() => {
  // <YoutubePlayer url='https://www.youtube.com/embed/M3rQ2fMnBQE' />
  // <img src={blob_img} className="App-header-image" alt="header" />
  const extraWideScreen = useMediaQuery('(min-width:1250px')
  const wideScreen = useMediaQuery('(min-width:1050px')
  const track = useTrackAnalytics()

  React.useEffect(() => {
    track('pageview')
  }, [track])

  return (
    <div
      style={{
        backgroundColor: '#FFFFFF',
        display: 'flex',
        flex: 1,
        width: '100%',
        alignItems: 'center',

        justifyContent: 'center',
        padding: 15,
        boxSizing: 'border-box',
      }}>
      {/* <img
        className='sb-mc sbg-i slzy'
        data-src='//static.showit.co/1600/X6FV4J9FQ9eIx-SygGNArw/61556/collage.jpg'
        width='1200'
        height='1200'
        src='//static.showit.co/1600/X6FV4J9FQ9eIx-SygGNArw/61556/collage.jpg'
        style={{
          width: 1425,
          height: 1425,
          inset: '-339.5px auto auto',
          position: 'absolute',
        }}
        alt='background'></img> */}
      <div
        style={{
          display: 'flex',
          backgroundColor: 'white',
          padding: 50,
          minWidth: '70%',
          width: 500,
          boxSizing: 'border-box',
          alignItems: 'center',
          justifyContent: wideScreen ? 'center' : 'flex-start',
          flexDirection: wideScreen ? 'row' : 'column',
        }}>
        <div style={{ position: 'relative' }}>
          <div
            style={{
              position: 'absolute',
              top: -40,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 0,
            }}>
            <T
              variant='h1'
              style={{
                transform: 'rotate(-3deg)',
                width: '100%',
                fontSize: wideScreen ? 72 : 60,
                fontFamily: 'Viva-Beautiful',
                color: '#dfdfdf',
                fontWeight: '100',
              }}>
              Let
              <i style={{ fontFamily: 'serif' }}>'</i>s Discover
              <i style={{ fontFamily: 'serif' }}>...</i>
            </T>
          </div>
          <T
            variant='h1'
            style={{
              fontSize: extraWideScreen ? 80 : wideScreen ? 60 : 50,
              marginBottom: '1rem',
              color: '#102947',
              fontWeight: 'bolder',
              marginTop: '2rem',
              zIndex: 1,
              lineHeight: wideScreen ? 0.9 : 1,
            }}>
            Discover Your
            <br />
            Podcast Style
          </T>

          <T style={{ fontSize: 20 }}>
            Whether you’re already rockin’ a side hustle (or two) or the idea of
            starting one sounds intriguing, you’ve just landed at the perfect
            quiz to get you to that NEXT chapter.
          </T>
          <div style={{ height: 30 }} />
          <Button
            component={Link}
            to='/quiz'
            style={{
              backgroundColor: '#f271b8',
              borderRadius: 99,
              color: 'black',
              paddingTop: 15,
              paddingBottom: 15,
              paddingLeft: 25,
              paddingRight: 25,
              margin: 15,
            }}>
            <T
              variant='h6'
              style={{
                fontWeight: '900',
                marginRight: 10,
                color: '#102947',
                marginTop: 1,
              }}>
              GET CLARITY NOW
            </T>
            <Icons.ArrowRight fill='#102947' />
          </Button>
        </div>
        <img
          src={microphone}
          // className='App-background-image'
          alt='microphone'
          style={{
            margin: 0,
            marginBottom: -5,
            marginLeft: -20,
            marginRight: -20,
            // width: 300,
            // minWidth: 700,
            width: 'auto',
            height: wideScreen ? 300 : 200,
            // minHeight: '100vw',
          }}
        />
      </div>
    </div>
  )

  // return (
  //   <div
  //     style={{
  //       backgroundColor: '#f2935f',
  //       display: 'flex',
  //       flex: 1,
  //       width: '100%',
  //       alignItems: 'center',
  //       justifyContent: wideScreen ? 'center' : 'flex-start',
  //       flexDirection: wideScreen ? 'row' : 'column',
  //     }}>
  //     <div>
  //       <T
  //         variant='h1'
  //         style={{
  //           fontSize: wideScreen ? 72 : 50,
  //           textAlign: 'left',
  //           marginBottom: '1rem',
  //           color: '#102947',
  //           fontWeight: 'bolder',
  //           marginTop: '2rem',
  //         }}>
  //         Discover Your
  //         <br />
  //         Podcast Style
  //       </T>
  //       <div style={{ height: 30 }} />
  //       <Button
  //         component={Link}
  //         to='/quiz'
  //         style={{
  //           backgroundColor: 'white',
  //           borderRadius: 99,
  //           color: 'black',
  //           paddingTop: 15,
  //           paddingBottom: 15,
  //           paddingLeft: 25,
  //           paddingRight: 25,
  //         }}>
  //         <T
  //           variant='h6'
  //           style={{ fontWeight: '900', marginRight: 10, color: '#102947' }}>
  //           GET CLARITY NOW
  //         </T>
  //         <Icons.ArrowRight fill='#102947' />
  //       </Button>
  //     </div>

  //     <img
  //       src={microphone}
  //       // className='App-background-image'
  //       alt='microphone'
  //       style={{
  //         margin: 0,
  //         marginBottom: -5,
  //         // width: 300,
  //         // minWidth: 700,
  //         width: 'auto',
  //         height: wideScreen ? 500 : 400,
  //         // minHeight: '100vw',
  //       }}
  //     />
  //   </div>
  // )
})

export default Home
